import {
  apiPaymentPath,
  apiPaymentPendingActionPath,
  apiPaymentProcessingPath,
  apiPaymentSuccessPath,
} from '@components/modules/apiPayment';
import {
  acceptInvitationPath,
  authMagicLinkPath,
  emailVerificationPath,
  emailVerificationSuccessPath,
  forgotPasswordPath,
  loginCallbackPath,
  loginPath,
  newPasswordPath,
  requestMagicLinkPath,
  resetPasswordPath,
  resetPasswordSuccessPath,
  resetPasswordWithOrgPath,
  signupCallbackPath,
  signupPath,
  verifyMagicLinkPath,
} from '@components/modules/auth/urls';
import { businessCreationPath } from '@components/modules/businessCreation';
import {
  customerPaymentPath,
  customerPaymentPendingActionPath,
  customerPaymentProcessingPath,
  customerPaymentSuccessPath,
  quickPayCustomerPaymentPath,
  quickPayCustomerPaymentPendingActionPath,
  quickPayCustomerPaymentProcessingPath,
  quickPayCustomerPaymentSuccessPath,
  quickPayCustomerPaymentWalletReturnPath,
} from '@components/modules/customerPayment';
import {
  recurringPaymentPath,
  recurringPaymentProcessingPath,
  recurringPaymentSuccessPath,
} from '@components/modules/recurringPayment';
import { matchPath } from 'react-router-dom';

// Routes that must stay reachable without a session. Auth failures on these
// pages must never trigger a hard redirect to login.
const publicPaths = [
  loginPath,
  signupPath,
  forgotPasswordPath,
  resetPasswordPath,
  resetPasswordWithOrgPath,
  resetPasswordSuccessPath,
  acceptInvitationPath,
  emailVerificationPath,
  emailVerificationSuccessPath,
  newPasswordPath,
  loginCallbackPath,
  signupCallbackPath,
  businessCreationPath,
  apiPaymentPath,
  apiPaymentSuccessPath,
  apiPaymentProcessingPath,
  apiPaymentPendingActionPath,
  customerPaymentPath,
  customerPaymentSuccessPath,
  customerPaymentProcessingPath,
  customerPaymentPendingActionPath,
  quickPayCustomerPaymentPath,
  quickPayCustomerPaymentSuccessPath,
  quickPayCustomerPaymentProcessingPath,
  quickPayCustomerPaymentPendingActionPath,
  quickPayCustomerPaymentWalletReturnPath,
  recurringPaymentPath,
  recurringPaymentSuccessPath,
  recurringPaymentProcessingPath,
  requestMagicLinkPath,
  verifyMagicLinkPath,
  authMagicLinkPath,
];

const cleanPath = (p: string) => (p.endsWith('/') && p !== '/' ? p.slice(0, -1) : p);

export const isPublicPath = (currentPath: string): boolean =>
  publicPaths.some((path) => {
    return (
      matchPath({ path, end: true }, currentPath) ||
      matchPath({ path: cleanPath(path), end: true }, cleanPath(currentPath))
    );
  });
